<template>
  <user-dashboard
    :autoRefresh="false"
    :tableStats="stats"
    :graphStats="stats"
    :statBarStats="statBarStats"
    :statBarSubStats="statsBarSubStats"
    :table-fields="['exchange_name']">
  </user-dashboard>
</template>

<script>
import UserDashboard from '@/components/UserDashboard'

export default {
  name: 'DemandDashboard',
  data () {
    return {
      stats: ['auctions', 'bids', 'bid_rate', 'clears', 'clear_rate', 'timeout_rate', 'avg_spend_cpm', 'spend'],
      statBarStats: ['auctions', 'bids', 'clears', 'fill_rate', 'timeout_rate', 'spend'],
      statsBarSubStats: [ { parent: 'bids', stat: 'bid_rate' }, { parent: 'clears', stat: 'clear_rate' }]
    }
  },
  components: {
    UserDashboard
  }
}
</script>



// WEBPACK FOOTER //
// src/demand/pages/Dashboard.vue